import { useState, type FormEvent } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Button, Card, InlineMessage, TextField } from '../components';
import { useLogin, useSession } from '../hooks/use-auth';
import { describeError } from '../services/errors';

interface LocationState {
  from?: string;
}

export function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const session = useSession();
  const login = useLogin();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  // Já autenticado: vai direto ao destino, sem piscar o formulário.
  if (session.data?.user) {
    return <Navigate to={(location.state as LocationState)?.from ?? '/'} replace />;
  }

  const handleSubmit = async (event: FormEvent): Promise<void> => {
    event.preventDefault();
    try {
      await login.mutateAsync({ email: email.trim(), password });
      navigate((location.state as LocationState)?.from ?? '/', { replace: true });
    } catch {
      // O erro é renderizado abaixo a partir de `login.error`; não há nada a
      // fazer aqui além de impedir que a exceção escape.
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm">
        <h1 className="mb-6 text-center text-xl font-semibold text-text">Pesquisa Social</h1>

        <Card>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4" noValidate>
            <TextField
              label="E-mail"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
            <TextField
              label="Senha"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />

            {login.isError && (
              <InlineMessage tone="danger">{describeError(login.error)}</InlineMessage>
            )}

            <Button type="submit" loading={login.isPending}>
              Entrar
            </Button>
          </form>
        </Card>

        <p className="mt-4 text-center text-xs text-text-muted">
          Acesso restrito. Contas são criadas pelo administrador.
        </p>
      </div>
    </div>
  );
}
